import script from "./BrandsEditor.vue?vue&type=script&setup=true&lang=js"
export * from "./BrandsEditor.vue?vue&type=script&setup=true&lang=js"

import "./BrandsEditor.vue?vue&type=style&index=0&id=38a44d9c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38a44d9c"]])

export default __exports__